/* eslint-disable no-undef */
(function (window) {
	"use strict";
	function defineTooltipHelper() {
		var tooltipHelper = {};
		tooltipHelper.tooltip = function(tooltipOptions){
			var options = { 
				html: true
			};
			var useCustomTemplate = false;
			console.log("tooltipOptions", tooltipOptions);
			if(tooltipOptions !== null && tooltipOptions !== undefined ){
				if(tooltipOptions.template !== null && tooltipOptions.template !== undefined){
					useCustomTemplate = true;
				}
				options = tooltipOptions;
			}
            
			$("[data-toggle=\"tooltip\"]").each(function(){
				//set styling for each tool tip
				if ($(this)[0].hasAttribute("data-type")) {
					if(!useCustomTemplate){
						options.template = 
                        "<div class=\"tooltip " + $(this).attr("data-type") + "\" role=\"tooltip\">" + 
                        "	<div class=\"arrow\"></div>" + 
                        "	<div class=\"tooltip-inner\"></div>" + 
                        "</div>";
					}
				}
				$(this).tooltip(options);
			});
		};
		return tooltipHelper;
	}
	//define globally if it doesn't already exist
	if (typeof (tooltipHelper) === "undefined") {
		window.tooltipHelper = defineTooltipHelper();
	} else {
		console.log("tooltipHelper already defined.");
	}
})(window);